module.exports = __webpack_public_path__ + "img/blue_177.85bc2cef.png";